import React from 'react';

import ContextMenu from 'flow/components/ContextMenu';
import VoicemailContextMenu from 'flow/components/context-menus/VoicemailContextMenu';
import useAppContext from 'flow/hooks/useAppContext';
import { TypedMap } from 'flow/types/TypedMap';
import { ExtensionVoiceMessage } from 'flow/types/VoiceMessage';
import { extractName } from 'flow/utils';
import { getMoreOptionsLabel } from 'flow/utils/a11y-utils';

interface Props {
    voiceMessage: TypedMap<ExtensionVoiceMessage>;
    onClickCreateContact: () => void;
    setActive: (value: boolean) => void;
}

// Own component so the translation subscription stays off the row, which
// re-renders on every playback and read-state change.
const VoicemailRowMenu = ({
    voiceMessage,
    onClickCreateContact,
    setActive,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <ContextMenu
            triggerLabel={getMoreOptionsLabel(
                i18next,
                extractName(voiceMessage.get('contact')),
            )}
            preventOverflow={true}
            setActive={setActive}
        >
            <VoicemailContextMenu
                voiceMessage={voiceMessage}
                onClickCreateContact={onClickCreateContact}
            />
        </ContextMenu>
    );
};

export default VoicemailRowMenu;
